export type ValidationErrorsProps<T extends Record<string, any>> = {
  fieldName: keyof T;
  checked: boolean;
  errors: string[] | null;
};

const ValidationErrors = <T extends Record<string, any>>({ fieldName, checked, errors }: ValidationErrorsProps<T>) => {
  if (!checked) return null;
  return (
    <div className="py-2">
      {errors?.map((error, index) => (
        <div key={`${String(fieldName)}-error-${index}`} className="text-xs text-red-5">
          {error}
        </div>
      ))}
    </div>
  );
};

export default ValidationErrors;
